import * as d3 from 'd3'

export default {

  methods: {

    event_Link(selection, col, data) {

      if (col.filter == '' || data[col.code] == 0) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(this.filters[col.filter], data) 
        })
    },

    link_Action(filter_, data) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })
      let filterString_ = filter_ || ''

      if (data.FILTER) {
        if (filterString_) filterString_ += ` AND ${data.FILTER}`
        else filterString_ += data.FILTER
      }

      let reqText = data.REQ_TEXT || 'request'

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(reqText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}